import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '@/api/client';

interface Cand { id: number; }

/**
 * Pantalla landing del rol CAN. Llama /me/candidato → redirige a su ficha.
 * Si no encuentra → mensaje (se le debe asignar primero el DNI a la posición).
 */
export function PortalCandidato() {
  const nav = useNavigate();
  const { data, isLoading, error } = useQuery<Cand>({
    queryKey: ['me-candidato'],
    queryFn: async () => (await api.get<Cand>('/me/candidato')).data,
    retry: false,
  });

  useEffect(() => {
    if (data?.id) nav(`/candidatos/${data.id}`, { replace: true });
  }, [data, nav]);

  if (isLoading) {
    return <div className="p-10 text-center text-sm text-gray-500">Cargando tu expediente…</div>;
  }

  if (error) {
    return (
      <div className="p-10 max-w-lg mx-auto">
        <div className="bg-amber-50 border border-amber-200 rounded p-6 text-sm">
          <h2 className="text-base font-semibold text-amber-900 mb-2">
            Aún no estás asignado a una posición
          </h2>
          <p className="text-amber-800 text-xs">
            Tu DNI no figura como candidato en el sistema. Si fuiste designado
            recientemente, espera a que el Personero Legal confirme la asignación
            con el Acta del CEN. Si crees que es un error, contacta al PLT.
          </p>
        </div>
      </div>
    );
  }

  return null;
}
